<app-modal-frame
  [headerText]="inputData.editMode ? CONSTS.EDIT_HEADER : CONSTS.HEADER"
  (emitExit)="clickExit()"
>
  <form [formGroup]="deviceForm" class="add-device-form">
    <div class="card-content">
      <ion-row class="wrapper">
        <!-- Employee ID -->
        <ion-col size="3">
          <app-form-text-field
            [labelText]="CONSTS.LABEL.EMPLOYEE_ID"
            [maxLength]="15"
            [minLength]="7"
            [form]="deviceForm"
            [regexType]="REGEX.ALPHABET_NUMBER_NO_SPACE"
            [control]="IDS.EMPLOYEE_ID"
            [placeholderText]="CONSTS.PLACEHOLDER.EMPLOYEE_ID"
            [autoCapitalizeCharacters]="true"
            (paste)="commonUtils.sanitizePaste($event, 'alphanumeric')"
          ></app-form-text-field>
        </ion-col>

        <!-- Email -->
        <ion-col size="5">
          <app-form-text-field
            [labelText]="CONSTS.LABEL.EMAIL"
            [maxLength]="80"
            [form]="deviceForm"
            [regexType]="REGEX.EMAIL"
            [control]="IDS.EMAIL"
            [placeholderText]="CONSTS.PLACEHOLDER.EMAIL"
            [autoCapitalizeCharacters]="true"
            (ionBlur)="trim(IDS.EMAIL)"
            (paste)="commonUtils.sanitizePaste($event, 'emailSafe')"
          ></app-form-text-field>
        </ion-col>

        <!-- Last Name-->
        <ion-col size="3">
          <app-form-text-field
            [labelText]="CONSTS.LABEL.LAST_NAME"
            [maxLength]="30"
            [form]="deviceForm"
            [regexType]="REGEX.ALPHA_SPACE_DASH"
            [control]="IDS.LAST_NAME"
            [placeholderText]="CONSTS.PLACEHOLDER.LAST_NAME"
            [autoCapitalizeCharacters]="true"
            (ionBlur)="trim(IDS.LAST_NAME)"
            (paste)="
              commonUtils.sanitizePaste($event, 'alphabetWithSpaceAndDash')
            "
          ></app-form-text-field>
        </ion-col>
      </ion-row>

      <ion-row>
        <!-- First Name-->
        <ion-col size="3">
          <app-form-text-field
            [labelText]="CONSTS.LABEL.FIRST_NAME"
            [maxLength]="30"
            [form]="deviceForm"
            [regexType]="REGEX.ALPHA_SPACE_DASH"
            [control]="IDS.FIRST_NAME"
            [placeholderText]="CONSTS.PLACEHOLDER.FIRST_NAME"
            [autoCapitalizeCharacters]="true"
            (ionBlur)="trim(IDS.FIRST_NAME)"
            (paste)="
              commonUtils.sanitizePaste($event, 'alphabetWithSpaceAndDash')
            "
          ></app-form-text-field>
        </ion-col>

        <!-- Location-->
        <ion-col size="3">
          <app-form-text-field
            [labelText]="CONSTS.LABEL.LOCATION"
            [form]="deviceForm"
            [control]="IDS.LOCATION"
            [readonly]="true"
          ></app-form-text-field>
        </ion-col>

        <!-- Status -->
        <ion-col size="3">
          <app-form-select
            [label]="CONSTS.LABEL.STATUS"
            [options]="STATUS_OPTIONS"
            [formControlName]="IDS.ENABLED"
            [required]="true"
            [hasAltHeight]="true"
            [isDisabled]="!this.inputData.editMode"
          ></app-form-select>
        </ion-col>
      </ion-row>

      <ion-row class="footer-row">
        <ion-col size="2">
          <ion-button
            class="reset-button button-text"
            fill="outline"
            size="default"
            onkeypress="clearText()"
            [disabled]="deviceForm.pristine"
            (click)="clearText()"
          >
            {{ CONSTS.CLEAR }}
          </ion-button>
        </ion-col>

        <ion-col offset="8" size="2">
          <ion-button
            class="continue-button button-text"
            size="default"
            onkeypress="onButtonClick()"
            [disabled]="deviceForm.pristine || deviceForm.invalid"
            (click)="onSubmit()"
          >
            {{ CONSTS.ADD }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </form>
</app-modal-frame>
